import { MessageLoadingSquare } from "./MessageLoadingSquare";

export function MinimalToolsIndicator({ message }: { message?: string }) {
  if (message) {
    return (
      <div className="text-muted-foreground text-sm py-1">
        <span className="animate-pulse">{message}</span>
      </div>
    );
  }

  return <MessageLoadingSquare />;
}
